import { render } from "./SettingsBar.vue?vue&type=template&id=00684674"
import script from "./SettingsBar.vue?vue&type=script&lang=js"
export * from "./SettingsBar.vue?vue&type=script&lang=js"

import "./SettingsBar.vue?vue&type=style&index=0&id=00684674&lang=css"
script.render = render

export default script